<div class="section-heading">

  <span class="section-small-title">
    {{ 'BRAND.BRAND' | translate }}
  </span>

  <h2>
    {{ 'BRAND.Shop_By_Brand' | translate }}
  </h2>

  <div class="title-line">
    <span>✦</span>
  </div>

</div>


<div
  class="brand-carousel"
  *ngIf="brands().length > 0"
>

  <!-- =====================================================
       LEFT ARROW
       ===================================================== -->

  <button
    type="button"
    class="carousel-arrow brand-arrow brand-prev"

    [disabled]="
      !hasBrandOverflow() ||
      isAtStart()
    "

    (click)="scrollBrands('left')"

    [attr.aria-label]="
      languageService.isArabic()
        ? 'العلامات التجارية السابقة'
        : 'Previous brands'
    "
  >

    <mat-icon>
      chevron_left
    </mat-icon>

  </button>


  <!-- =====================================================
       BRAND TRACK
       ===================================================== -->

  <div
    class="horizontal-track brand-track"
    #brandTrack
  >

    <div
      class="brand-card"
      *ngFor="let brand of brands()"
      (click)="selectBrand(brand)"
    >

      <div class="brand-image">

        <img
          [src]="getBrandImage(brand)"
          [alt]="getBrandName(brand)"
          loading="lazy"
        />

      </div>

      <h3>
        {{ getBrandName(brand) }}
      </h3>

    </div>

  </div>


  <!-- =====================================================
       RIGHT ARROW
       ===================================================== -->

  <button
    type="button"
    class="carousel-arrow brand-arrow brand-next"

    [disabled]="
      !hasBrandOverflow() ||
      isAtEnd()
    "

    (click)="scrollBrands('right')"

    [attr.aria-label]="
      languageService.isArabic()
        ? 'العلامات التجارية التالية'
        : 'Next brands'
    "
  >

    <mat-icon>
      chevron_right
    </mat-icon>

  </button>

</div>